import React from 'react';

interface ReadingGoalCardProps {
  booksRead: number;
  goal: number;
  className?: string;
}

const ReadingGoalCard: React.FC<ReadingGoalCardProps> = ({ booksRead, goal, className }) => {
  // Calculate progress for the donut chart
  const percent = Math.min(booksRead / goal, 1);
  const radius = 56;
  const stroke = 10;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const progress = circumference * (1 - percent);

  return (
    <div className={`bg-white rounded-lg p-6 shadow-sm h-full flex flex-col ${className || ''}`}>
      {/* Header with icon and subtitle */}
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#F3F0FF]">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="7.5" stroke="#A084E8" strokeWidth="1.5" />
            <circle cx="9" cy="9" r="3" fill="#A084E8" />
          </svg>
        </span>
        <div>
          <div className="text-sm font-semibold text-gray-900 leading-tight">Reading Goal</div>
          <div className="text-xs text-gray-500 leading-tight">This year</div>
        </div>
      </div>
      {/* Donut Chart and Number */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <div className="relative flex items-center justify-center">
          <svg className="w-32 h-32" viewBox="0 0 128 128">
            <circle
              cx="64"
              cy="64"
              r={normalizedRadius}
              stroke="#F1F1F6"
              strokeWidth={stroke}
              fill="none"
            />
            <circle
              cx="64"
              cy="64"
              r={normalizedRadius}
              stroke="#A084E8"
              strokeWidth={stroke}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={progress}
              strokeLinecap="round"
              transform="rotate(-90 64 64)"
              style={{ transition: 'stroke-dashoffset 0.5s' }}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl font-bold text-gray-900">{booksRead}<span className="text-gray-400">/{goal}</span></span>
          </div>
        </div>
      </div>
      {/* Label below chart */}
      <div className="text-center mt-2">
        <span className="text-sm text-gray-700">Books read this year</span>
      </div>
    </div>
  );
};

export default ReadingGoalCard; 